import { createSlice } from '@reduxjs/toolkit';

interface NotificationState {
  newNotificationReceived: boolean;
  panelClosed: boolean;
}

const initialState: NotificationState = {
  newNotificationReceived: false,
  panelClosed: false,
};

export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    triggerNewNotification: (state) => {
      state.newNotificationReceived = true;
    },
    resetNewNotification: (state) => {
      state.newNotificationReceived = false;
    },
    notifyPanelClosed: (state) => {
      state.panelClosed = true;
    },
    resetPanelClosed: (state) => {
      state.panelClosed = false;
    },
  },
});

export const {
  triggerNewNotification,
  resetNewNotification,
  notifyPanelClosed,
  resetPanelClosed,
} = notificationSlice.actions;

export default notificationSlice.reducer;
